function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM6.036 6.019a.626.626 0 01.89 0l3.307 3.312 3.258-3.236a.633.633 0 01.89 0 .62.62 0 010 .882l-3.263 3.24 3.281 3.288a.634.634 0 010 .893.626.626 0 01-.889 0l-3.286-3.292L6.908 14.4a.633.633 0 01-.89 0 .62.62 0 010-.882l3.32-3.298-3.302-3.308a.634.634 0 010-.893z"
});
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref);
}
export default SvgClose;